import logoImg from "../../assets/images/astm-internal.png";
import React, { useState } from "react";
import lodash from "lodash";
import { Image } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import NavigationMenu from "../NavigationMenu";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../common.actions";
import SearchBox from "../SearchBox";
import { checkUserPermissionOnPage } from "../../helpers/util-common";
import { PAGE_TYPE, USER_PRIVILEGE } from "../../models/navigation.models";

type Option = {
  text: string;
  value: string;
  key: string;
};
interface Props {
  userDetail?: any;
  history?: any;
  showNotFoundPage?: any;
  onGlobalSearchSubmit: any;
  toggleAdvanceSearchVisibility?: any
  onAdvanceSearchSubmit: any;
  committeeData: any;
  ballotDesignationData: any;
  wiListData: any;
  witnListData: any;
  standardListData: any;
  setAdvBallotSearchFormData: any;
  setAdvWorkitemSearchFormData:any;
  ballotAdvanceSearchFormData: any;
  wiAdvanceSearchFormData: any;
  ballotStatusOption: Option[];
  wiStatusOption: Option[];
  resetClicked: boolean;
  setResetClicked: any;
  loadAdvanceSearchData: (flow: string) => void
}
export const HeaderMenu: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const applogout = () => {
    logout(dispatch);
  };
  const userPermission = useSelector((state: any) => state.commonReducer.userPermission);
  return (
    <header data-testid="headertest">
      <div className="container-fluid">
        <div className="headerWrap">
          <div className="logoWrap height-34">
            <a href="">
              <img src={logoImg} alt="ASTM Logo" />
            </a>
          </div>
          <div className="top-right-section">
          {checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW) || checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW)}
          <div className="searchWrap">
            <SearchBox loadAdvanceSearchData={props.loadAdvanceSearchData} {...props} ballotStatusOption={props.ballotStatusOption} onGlobalSearchSubmit={props.onGlobalSearchSubmit} resetClicked={props.resetClicked} setResetClicked={props.setResetClicked}/>
          </div>
          <div className="headerFilterhWrap">
            <div className="profileOptionMenu dropdown">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn astm-btn btn-primary yellow-btn profile-dropdown">
                  <i className="fas fa-user-circle astm-icon" style={{ marginInlineEnd: 4 }}></i>
                  {props.userDetail ? lodash(props.userDetail).get("userName", "").toLocaleUpperCase() : ""}
                </Dropdown.Toggle>

                {props.userDetail ? (
                  <Dropdown.Menu>
                    <Dropdown.Item data-testid="logout-id" onClick={applogout}>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                ) : (
                  ""
                )}
              </Dropdown>
            </div>
          </div>
        </div>
        </div>
      </div>
      <NavigationMenu history={props.history}></NavigationMenu>
    </header>
  );
};
export default HeaderMenu;
